module.exports = __webpack_public_path__ + "static/media/bg.96da8bc6.png";